/* eslint-disable */
import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from './views/Dashboard'
import Offers from './views/Offers'
import OfferIndex from './components/offers/OfferIndex'
import OfferForm from './components/offers/OfferForm'
import Reports from './views/Reports'
import Login from './components/users/Login'
import Sets from './views/Sets.vue'
import SetIndex from './components/sets/SetIndex'
import SetForm from './components/sets/SetForm'
import Users from './views/Users.vue'
import UserIndex from './components/users/UserIndex'
// not component imports
import Auth from './lib/auth/Auth.js'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  hash: true,
  routes: [
    {
      path: '*',
      name: 'NotFound',
      component: require('./components/errors/NotFound').default,
      meta: { layout: 'error' }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        layout: 'noauth'
      }
    },
    {
      path: '/logout',
      name: 'logout',
      component: Login,
      meta: {
        layout: 'noauth'
      }
    },
    {
      path: '/',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        title: 'Dashboard',
        auth: true
      }
    },
    {
      path: '/offers',
      component: () => import( './views/Offers.vue'),
      children: [
        { path: '', name: 'offers', component: OfferIndex, meta: { title: 'Offers', auth: true } },
        { path: 'create', name: 'create offer', component: OfferForm, meta: { title: 'New Offer', auth: true } },
        { path: 'edit/:id', name: 'edit offer', component: OfferForm, meta: { title: 'Edit Offer', auth: true  } }
      ]
    },
    {
      path: '/reports',
      name: 'reports',
      component: () => import( './views/Reports.vue'),
      children: [
        { path: 'sets', name: 'sets report', component: require('./components/reports/SetsReport').default, meta: { title: 'Sets Report', auth: true } },
        { path: 'offers', name: 'offers report', component: require('./components/reports/OffersReport').default, meta: { title: 'Offer Report', auth: true  } },
        { path: 'progression', name: 'progression report', component: require('./components/reports/ProgressionReport').default, meta: { title: 'Progression Report', auth: true  } },
      ]
    },
    {
      path: '/sets',
      component: Sets,
      children: [
        { path: '', name: 'sets', component: SetIndex, meta: { title: 'Sets', auth: true } },
        { path: 'create', name: 'create set', component: SetForm, meta: { title: 'New Set', auth: true } },
        { path: 'edit/:id', name: 'edit set', component: SetForm, meta: { title: 'Edit Set',auth: true } },

      ]
    },
    {
      path: '/users',
      component: Users,
      children: [
        { path: '', name: 'users', component: UserIndex, meta: { title: ' Users', auth: true } },
        { path: 'create', name: 'create user', component: require('./components/users/UserForm').default, meta: { title: 'New User', auth: true } },
        { path: 'edit/:id', name: 'edit user', component: require('./components/users/UserForm').default, meta: { title: 'Edit User', auth: true } }
      ]
    }
  ]
})
NProgress.configure({
  showSpinner: false,
  easing: 'ease',
  speed: 900
})

router.beforeResolve((to, from, next) => {
  if (to.name || to.children.name) {
    NProgress.start()
  }
  next()
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.auth)) {
    let claims = Auth.getClaims()
    if (claims) {
      next()
    } else {
      next('/login')
    }
  } else {
    next()
  }
})

const defaultTitle = 'Daisy - A DMS Product'
router.afterEach((to, from) => {
  NProgress.done()
  document.title = to.meta.title || defaultTitle
})

export default router
